export interface CategoryItem {
  key: string;
  name: string;
  path: string;
  description: string;
  icon: string;
  count: string;
}

export const categories: CategoryItem[] = [
  {
    key: 'variety',
    name: '综艺资讯',
    path: '/category/variety',
    description: '最新综艺节目动态与深度报道',
    icon: 'ri-tv-2-line',
    count: '1,286 篇',
  },
  {
    key: 'news',
    name: '娱乐新闻',
    path: '/category/news',
    description: '娱乐圈热点话题与行业观察',
    icon: 'ri-newspaper-line',
    count: '964 篇',
  },
  {
    key: 'videos',
    name: '趣味视频',
    path: '/category/videos',
    description: '轻松搞笑短视频与名场面',
    icon: 'ri-play-circle-line',
    count: '538 个',
  },
  {
    key: 'search',
    name: '全站搜索',
    path: '/search',
    description: '关键词一键找到想看的内容',
    icon: 'ri-search-eye-line',
    count: '全站内容',
  },
];

export const platforms: string[] = [
  '全部平台',
  '芒果TV',
  '浙江卫视',
  '湖南卫视',
  '东方卫视',
  '腾讯视频',
  '流媒体',
];

export const varietyTypes: string[] = [
  '全部类型',
  '音乐竞演',
  '户外竞技',
  '棚内综艺',
  '慢综艺',
  '脱口秀',
  '旅行',
  '选秀',
];

export const newsTopics: string[] = [
  '全部话题',
  '电影市场',
  '音乐节',
  '剧集',
  '公益',
  '综艺市场',
  '颁奖礼',
  '演唱会',
  '热梗',
];

export const videoTags: string[] = [
  '全部标签',
  '搞笑',
  '段子',
  '综艺剪辑',
  '名场面',
  '舞蹈',
  '萌宠',
  '反转',
];

export const timeRanges: string[] = ['全部时间', '最近一周', '最近一月', '最近三月'];